import { datadogRum } from "@datadog/browser-rum";

import { isProductionEnvironment } from "./config";

interface InitRumArgs {
	name: string;
	version: string;
	env: string;
	ddToken: string;
	ddAppId: string;
}

const getTelemetrySampleRate = (): number => {
	// Production environments have a 10% sample rate
	if (isProductionEnvironment()) return 10;

	// All other environments have a 100% sample rate
	return 100;
};

export const initRealUserMonitoring = ({ name, version, env, ddToken, ddAppId }: InitRumArgs) => {
	// Setup Datadog RUM functionality
	datadogRum.init({
		clientToken: ddToken,
		site: "datadoghq.com",
		service: name,
		env,
		telemetrySampleRate: getTelemetrySampleRate(),
		trackSessionAcrossSubdomains: false,
		version,
		applicationId: ddAppId,
	});
};
